// extracted by mini-css-extract-plugin
export default {"filters":"PromotionsFilter_filters__f95-7","filterBtn":"PromotionsFilter_filterBtn__Z-+Sf","filterActive":"PromotionsFilter_filterActive__KU5IM"};